import {
  Button,
  Card,
  CardActions,
  CardContent,
  DialogContentText,
  CardMedia,
  Typography,
} from "@mui/material";
import ManualCarousel, {
  CarouselItem,
} from "../components/people-carousel/PeopleCarousel";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useState } from "react";

const People = ({ team }) => {
  const [open, setOpen] = useState(false);
  const [cardData, setCardData] = useState([]);

  const people = [];
  let chunkSize = 6;

  for (let i = 0; i < team?.length; i += chunkSize) {
    const chunk = team?.slice(i, i + chunkSize);
    people.push(chunk);
  }

  const handleClickOpen = (data) => {
    setOpen(true);
    setCardData(data);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{ fontSize: "2rem", fontWeight: "bold" }}
        >
          {cardData?.name}
          <br /> <span className="font-medium">{cardData?.position}</span>
        </DialogTitle>

        <DialogContent>
          <DialogContent id="alert-dialog-description">
            <CardMedia
              className="w-40 h-40 md:w-60 md:h-60 lg:w-48 lg:h-48 xl:w-80 xl:h-80 transform transition-all duration-100 ease-linear"
              component="img"
              height="150"
              image={cardData?.image}
              alt="Article"
            />

            <DialogContentText style={{ fontSize: "1.3em" }}>
              {cardData?.email}
            </DialogContentText>
            <DialogContentText style={{ fontSize: "1.3em" }}>
              +0964{cardData?.phone}
            </DialogContentText>
            <DialogContentText style={{ fontSize: "1.3em" }}>
              {cardData?.description}
            </DialogContentText>
          </DialogContent>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <div className="h-fit py-14 xl:py-20 px-2 md:px-7 lg:px-0 lg:w-5/6 xl:w-4/5 mx-auto mb-140 md:mb-20 lg:mb-110 xl:mb-96">
        <h2 className="mb-10 xl:mb-20 text-4xl xl:text-5xl">Our People</h2>

        <ManualCarousel className="h-96 lg:w-5/6 xl:w-4/5 mx-auto overflow-x-clip">
          {people.map((person, i) => (
            <CarouselItem key={i}>
              {person.map((p) => (
                <Card
                  sx={{ maxWidth: 250 }}
                  key={p._id}
                  className="m-1 md:m-4 transform transition-all duration-100 ease-linear hover:border-2 border-blue-600 border-opacity-60 hover:shadow-xl"
                >
                  <CardMedia
                    className="px-3 pt-1 h-48 md:h-60 transform transition-all duration-100 ease-linear hover:p-0"
                    component="img"
                    image={p.image}
                    alt="Article"
                  />
                  <CardContent>
                    <Typography
                      style={{ margin: 0, padding: 0, fontSize: "1.25rem" }}
                      gutterBottom
                      variant="h5"
                      component="div"
                    >
                      {p.name}
                    </Typography>
                    <Typography
                      style={{ margin: 0, padding: 0, fontSize: "1rem" }}
                      gutterBottom
                      variant="h6"
                      component="div"
                      className="hidden md:block"
                    >
                      {p.position}
                    </Typography>
                    <Typography
                      style={{ margin: 0, padding: 0 }}
                      variant="caption"
                      className="inline-block whitespace-pre-line"
                      color="text.secondary"
                    >
                      {p.description.slice(0, 100)}...
                    </Typography>
                  </CardContent>
                  <CardActions
                    style={{ margin: "0 4px 4px 0", padding: 0 }}
                    className="flex justify-end"
                  >
                    <Button
                      onClick={() => handleClickOpen(p)}
                      style={{
                        backgroundColor: "#001A6C",
                        fontSize: "10px",
                        textTransform: "capitalize",
                        borderRadius: "0",
                      }}
                      variant="contained"
                      size="small"
                      color="primary"
                    >
                      Read More
                    </Button>
                  </CardActions>
                </Card>
              ))}
            </CarouselItem>
          ))}
        </ManualCarousel>
      </div>
    </>
  );
};

export default People;
